/** Lowercased, accent-stripped, single-spaced — for substring search. */
export function normalize(s) {
    return s
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
}
/** Highlight matches of `query` in `text` by wrapping with <mark>. */
export function highlight(text, query) {
    if (!query.trim())
        return { __html: escapeHtml(text) };
    const norm = normalize(query);
    const tokens = norm.split(' ').filter(Boolean);
    if (!tokens.length)
        return { __html: escapeHtml(text) };
    // Build a regex that matches any token, accent-insensitively
    const escaped = tokens.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
    const re = new RegExp(`(${escaped})`, 'gi');
    // We compare against the normalized text to find matches, then map back to indices.
    const normText = normalize(text);
    const matches = [];
    let m;
    while ((m = re.exec(normText)) !== null) {
        matches.push([m.index, m.index + m[0].length]);
        if (m.index === re.lastIndex)
            re.lastIndex++;
    }
    if (!matches.length)
        return { __html: escapeHtml(text) };
    // Use mapping: since normalize() may change length (accents → simple chars typically same len; spaces collapsed).
    // For our purposes, accents are 1:1 so positions align. But collapsed spaces may shift.
    // Simple safe fallback: just escape and bold matched substrings via the original-text matching with a relaxed regex.
    const tokensSafe = tokens.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    const reAccentInsensitive = new RegExp('(' +
        tokensSafe
            .map((t) => t
            .split('')
            .map((c) => accentClass(c))
            .join(''))
            .join('|') +
        ')', 'gi');
    const out = escapeHtml(text).replace(reAccentInsensitive, '<mark>$1</mark>');
    return { __html: out };
}
function accentClass(c) {
    const map = {
        a: '[aáàäâãAÁÀÄÂÃ]',
        e: '[eéèëêEÉÈËÊ]',
        i: '[iíìïîIÍÌÏÎ]',
        o: '[oóòöôõOÓÒÖÔÕ]',
        u: '[uúùüûUÚÙÜÛ]',
        n: '[nñNÑ]',
    };
    return map[c.toLowerCase()] ?? c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function escapeHtml(s) {
    return s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
//# sourceMappingURL=normalize.js.map